export { LovFieldType } from 'choerodon-ui/dataset/enum';
export var ViewMode;
(function (ViewMode) {
    ViewMode["default"] = "default";
    ViewMode["button"] = "button";
})(ViewMode || (ViewMode = {}));
export var PrefixRule;
(function (PrefixRule) {
    PrefixRule["start"] = "start";
    PrefixRule["end"] = "end";
    PrefixRule["include"] = "include";
})(PrefixRule || (PrefixRule = {}));
export var SearchAction;
(function (SearchAction) {
    SearchAction["blur"] = "blur";
    SearchAction["input"] = "input";
})(SearchAction || (SearchAction = {}));
